import React from "react";

const BanedPage = () => {
  return (
    <div className="w-full h-full fixed z-50 flex items-center justify-center px-4 bg-black/80">
      <div className="bg-[#1E2B3B] rounded-lg p-5 text-white text-center ">
        <h4 className="text-[18px] text-red-500 mb-3 font-bold">
          You are baned!
        </h4>
        <p>You have been banned for some suspicious activity.</p>
      </div>
    </div>
  );
};

export default BanedPage;
